import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import { useGetProjectHotelsForPMS } from "../../../hooks/project.hooks";
import { PMS_ALL_VALUE } from "../../../utils/pms.utils";
import { HOTEL_STATUS_LOST, HOTEL_STATUS_SOLD } from "../../../utils/hotel.utils";

const { Option } = Select;

const ProjectPMSHotelSelect = ({
  value,
  onChange,
  projectId,
  pmsId,
  excludedHotelStatus,
  setPMSHotelListRef,
  ...rest
}) => {
  const { data, isLoading } = useGetProjectHotelsForPMS(projectId, pmsId, {
    enabled: !!projectId && !!pmsId && pmsId !== PMS_ALL_VALUE,
  });

  useEffect(() => {
    onChange(undefined);
  }, [projectId, pmsId]);

  const filteredHotels = useMemo(() => {
    if (Array.isArray(data)) {
      return data.filter(
        (hotel) => !excludedHotelStatus.includes(hotel.hotel_status),
      );
    }
    return [];
  }, [data]);

  useEffect(() => {
    if (setPMSHotelListRef !== undefined) {
      setPMSHotelListRef(filteredHotels);
    }
  }, [filteredHotels]);

  return (
    <Select
      placeholder="Hotel"
      value={value}
      onChange={onChange}
      showSearch
      optionFilterProp="children"
      filterOption={(input, option) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      loading={isLoading}
      {...rest}
    >
      {Array.isArray(filteredHotels) &&
        filteredHotels.map((hotel) => (
          <Option value={hotel._id} key={hotel._id}>
            {`${hotel.hotel_code} - ${hotel.hotel_name}`}
          </Option>
        ))}
    </Select>
  );
};

ProjectPMSHotelSelect.defaultProps = {
  pmsId: undefined,
  projectId: undefined,
  value: undefined,
  onChange: () => {},
  setPMSHotelListRef: () => {},
  excludedHotelStatus: [HOTEL_STATUS_LOST, HOTEL_STATUS_SOLD],
};

ProjectPMSHotelSelect.propTypes = {
  pmsId: PropTypes.string,
  projectId: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  setPMSHotelListRef: PropTypes.func,
  excludedHotelStatus: PropTypes.arrayOf(PropTypes.string),
};

export default ProjectPMSHotelSelect;
